import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {DisclaimerComponent} from './disclaimer/disclaimer.component';
import {PrivacyPolicyComponent} from './privacy-policy/privacy-policy.component';

const routes: Routes = [
  { path: '', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
  { path: 'insights', loadChildren: () => import('./insights/insights.module').then(m => m.InsightsModule) },
  { path: 'disclaimer', component: DisclaimerComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
